<template>
    <div class="page">
        <div class="page-content">
            <el-form
            style="margin-top: 10px;"
            :model="imWebimCustomer"
            ref="imWebimCustomerForm"
            :rules="rules"
            label-width="120px"
            size="small"
            >
            <el-form-item
                label="用户"
                prop="userId"
                style="max-width: 400px;"
            >
            <GridSelectU style="width: 280px;" labelName="userName"
                labelValue="id" title="选择用户" :value="imWebimCustomer.userId" :limit='1' size='small' placeholder='请选择用户'
                @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
            </el-form-item>
            <el-form-item
                label="客服名称"
                prop="customerName"
                style="max-width: 400px;"
            >
                <el-input
                size="small"
                v-model="imWebimCustomer.customerName"
                
                ></el-input>
        </el-form-item>
            <el-form-item
                label="问候语"
                prop="greeting"
                style="max-width: 400px;"
            >
                <el-input
                size="small"
                v-model="imWebimCustomer.greeting"
                
                ></el-input>
            </el-form-item>
            <el-form-item
                label="公司名称"
                prop="companyName"
                style="max-width: 400px;"
            >
                <el-input
                size="small"
                v-model="imWebimCustomer.companyName" 
                ></el-input>
            </el-form-item>
            <el-form-item
                label="公司简介"
                prop="companyDescription"
                style="max-width: 400px;"
            >
                <el-input
                size="small"
                type="textarea"
                :rows="8"
                v-model="imWebimCustomer.companyDescription"
                ></el-input>
            </el-form-item>
            <el-form-item
                label="是否多坐席"
                prop="multipleSeat"
                style="max-width: 400px;"
            >
            <el-select
              size="small"
              style="width:280px"
              v-model="imWebimCustomer.multipleSeat"
            >
              <el-option
                label="是"
                :value="1"
              ></el-option>
              <el-option
                label="否"
                :value="0"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="托管给系统"
            prop="aiCustomer"
            style="max-width: 400px;"
          >
            <!-- <el-input
              size="small"
              v-model="imWebimCustomer.aiCustomer"
              :disabled="imWebimCustomerState == 'check'"
            ></el-input> -->
            <el-select
              size="small"
              style="width:280px"
              v-model="imWebimCustomer.aiCustomer"
            >
              <el-option
                label="是"
                :value="1"
              ></el-option>
              <el-option
                label="否"
                :value="0"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="客服头像"
            prop="customerHeader"
            style="max-width: 400px;"
          >
            <!-- <el-input
              size="small"
              style="width: 177px;"
              v-model="imWebimCustomer.customerHeader"
              :disabled="imWebimCustomerState == 'check'"
            ></el-input> -->
            <el-upload
                style="width: 200px"
                class="avatar-uploader"
                action=""
                :show-file-list="false"
                :http-request="uploadAvatar">
                <img v-if="imWebimCustomer.customerHeader" :src="imWebimCustomer.customerHeader" class="avatar" size="small" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
        <div class="bottm-btn">
            <el-button style="margin-left: 30px" type="primary" size='small' @click="submitForm">确认修改</el-button>
        </div>
        </div>
    </div>
</template>
<script>
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import { UPLOAD_PATH, UPLOAD_API, USER, PRODUCT, PRODUCT_SEARCH, USER_SEARCH } from '@/utils/constant.js';
import GridSelectU from '@/components/gridselect';
export default {
    components:{
        GridSelectU
    },
    data(){
        return{
            USER_code: USER,
            USER_search: USER_SEARCH,
            imWebimCustomer: {
                id: '', //ID
                userId: '', //用户
                customerName: '', //客服名称
                customerHeader: '', //客服头像
                greeting: '', //问候语
                companyName: '', //公司名称
                companyDescription: '', //公司简介
                multipleSeat: '', //默认单坐席0  可选多坐席1
                aiCustomer: '', //0 人工客服 1 智能客服
                createTime: '', //
            },
            rules: {
                userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                customerName: [{ required: true, message: '客服名称不能为空', trigger: 'blur' }],
                customerHeader: [{ required: true, message: '客服头像不能为空', trigger: 'blur' }],
                greeting: [{ required: true, message: '问候语不能为空', trigger: 'blur' }],
                companyName: [{ required: true, message: '公司名称不能为空', trigger: 'blur' }],
                companyDescription: [{ required: true, message: '公司简介不能为空', trigger: 'blur' }],
                multipleSeat: [{ required: true, message: '默认单坐席0  可选多坐席1不能为空', trigger: 'blur' }],
                aiCustomer: [{ required: true, message: '0 人工客服 1 智能客服不能为空', trigger: 'blur' }],
                createTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
            }
        }
    },
    created(){
        this.getImWebimCustomerById();
    },
    methods:{
        getValueUser(value) {
            this.imWebimCustomer.userId = value
        },
        //上传缩略图
        uploadAvatar(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.imWebimCustomer.customerHeader = res.url;
                }
            });
        },
        getImWebimCustomerById() {
            get(`im/webimcustomer/getMyCustomer`).then((res) =>{
                if(res.success){
                    console.log(res)
                    this.imWebimCustomer = { ...this.imWebimCustomer, ...res.customer };
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        submitForm(){
            this.$refs.imWebimCustomerForm.validate((valid) => {
                if (valid) {
                    console.log('submit');
                    post(`/im/webimcustomer/edit`,{ ...this.imWebimCustomer }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.getImWebimCustomerById();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}
.avatar {
    width: 200px;
    height: 200px;
    display: block;
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}
</style>